const oneDecimal = new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 });

export const count = (value: number): string => new Intl.NumberFormat().format(value);
/** The design drops a trailing ".0" ("83%", "9.1%"). */
export const percent = (value: number | null): string => value === null ? '—' : `${oneDecimal.format(value)}%`;
export const money = (value: string | number | null, currency: string | null): string =>
  value === null || !currency ? '—' : new Intl.NumberFormat(undefined, { style: 'currency', currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(value));
export function relativeChange(current: number, previous: number): number | null {
  return previous > 0 ? (current - previous) / previous * 100 : null;
}
/** Chart axis amounts: "₹24k", "₹1.2M", "₹0". */
export function compactMoney(value: number, currency: string | null): string {
  const symbol = currency
    ? new Intl.NumberFormat(undefined, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).formatToParts(0).find((part) => part.type === 'currency')?.value ?? ''
    : '';
  if (value >= 1_000_000) return `${symbol}${oneDecimal.format(value / 1_000_000)}M`;
  if (value >= 1_000) return `${symbol}${oneDecimal.format(value / 1_000)}k`;
  return `${symbol}${oneDecimal.format(value)}`;
}
const monthName = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short' });
const utcDay = (date: string): Date => new Date(`${date}T00:00:00Z`);
/** "13 Sep" for axis ticks. */
export const shortDate = (date: string): string => `${utcDay(date).getUTCDate()} ${monthName.format(utcDay(date))}`;
/** "9 Oct 2026" for the tooltip. */
export const longDate = (date: string): string => `${shortDate(date)} ${utcDay(date).getUTCFullYear()}`;
